import { z } from 'zod';

export const SubjectPersonGroupSchema = z.object({
    id: z.union([z.string(), z.number()]).optional(),
    name: z.string().min(1), // e.g., 'Employees', 'Customers'
    description: z.string().optional(),
    createdAt: z.union([z.string(), z.date()]).optional(),
    updatedAt: z.union([z.string(), z.date()]).optional(),
    customFields: z.record(z.unknown()).optional(),
});

export const CreateSubjectPersonGroupSchema = SubjectPersonGroupSchema.omit({ id: true });
export const UpdateSubjectPersonGroupSchema = SubjectPersonGroupSchema;
export const SubjectPersonGroupFormSchema = z.object({
    id: z.union([z.string(), z.number()]).optional(),
    name: z.string().min(1, "form.validation.nameRequired"),
    description: z.string().min(1, "form.validation.descriptionRequired"),
});